(function(){
  function moneyFmt(cents){
    const code=(window.Lumitierra && window.Lumitierra.currency) || 'USD';
    try{ return new Intl.NumberFormat('en-US',{style:'currency',currency:code}).format((cents||0)/100); }
    catch(e){ return ((cents||0)/100).toFixed(2)+' '+code; }
  }

  function renderCartDrawer(cart){
    const itemsEl=document.querySelector('[data-cart-items]');
    const subtotalEl=document.querySelector('[data-cart-subtotal]');
    const shippingMsg=document.querySelector('[data-shipping-msg]');
    if(!itemsEl) return;
    const threshold=(window.Lumitierra && window.Lumitierra.freeShippingThreshold) || 6900;
    const remaining=Math.max(0,threshold-cart.total_price);
    const percent=Math.min(100,(cart.total_price/threshold)*100);
    if(shippingMsg){
      const barHtml='<div class="shipping-bar"><div class="shipping-bar-fill" style="width:'+percent+'%"></div></div>';
      shippingMsg.innerHTML=(remaining>0
        ? ('<strong>'+moneyFmt(remaining)+'</strong> away from free shipping')
        : '✓ Free shipping unlocked') + barHtml;
    }
    if(subtotalEl) subtotalEl.textContent=moneyFmt(cart.total_price);
    if(cart.item_count===0){
      itemsEl.innerHTML='<div class="cart-drawer-empty"><p>Your cart is empty.</p></div>';
      return;
    }
    itemsEl.innerHTML=cart.items.map(function(item,i){
      const img=item.image ? ('<img src="'+item.image+'" alt="" width="64" height="64" loading="lazy">') : '';
      const variant=(item.variant_title && item.variant_title!=='Default Title') ? ('<p>'+item.variant_title+'</p>') : '';
      return '<div class="drawer-item" data-line="'+(i+1)+'">'
        + '<a href="'+item.url+'">'+img+'</a>'
        + '<div class="drawer-item-info"><h3><a href="'+item.url+'">'+item.product_title+'</a></h3>'+variant
        + '<div class="drawer-qty"><button type="button" data-qty-decrease>−</button><span data-qty-value>'+item.quantity+'</span><button type="button" data-qty-increase>+</button></div>'
        + '<a class="drawer-remove" href="#" data-remove-line>Remove</a></div>'
        + '<div class="drawer-item-price">'+moneyFmt(item.final_line_price)+'</div></div>';
    }).join('');
  }

  function refreshCart(){
    return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count;});
      renderCartDrawer(cart);
      return cart;
    });
  }

  function openDrawer(){
    const d=document.querySelector('[data-cart-drawer]');
    const o=document.querySelector('[data-cart-overlay]');
    if(d) d.classList.add('is-open');
    if(o) o.classList.add('is-open');
    document.body.classList.add('cart-drawer-open');
  }
  function closeDrawer(){
    const d=document.querySelector('[data-cart-drawer]');
    const o=document.querySelector('[data-cart-overlay]');
    if(d) d.classList.remove('is-open');
    if(o) o.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
  }

  function openMobileMenu(){
    const m=document.querySelector('[data-mobile-menu]');
    const o=document.querySelector('[data-mobile-overlay]');
    const t=document.querySelector('[data-menu-toggle]');
    if(m) m.classList.add('is-open');
    if(o) o.classList.add('is-open');
    if(t) t.setAttribute('aria-expanded','true');
    document.body.classList.add('mobile-menu-open');
  }
  function closeMobileMenu(){
    const m=document.querySelector('[data-mobile-menu]');
    const o=document.querySelector('[data-mobile-overlay]');
    const t=document.querySelector('[data-menu-toggle]');
    if(m) m.classList.remove('is-open');
    if(o) o.classList.remove('is-open');
    if(t) t.setAttribute('aria-expanded','false');
    document.body.classList.remove('mobile-menu-open');
  }

  function changeLine(line,quantity){
    return fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({line:line,quantity:quantity})
    }).then(refreshCart);
  }

  document.addEventListener('click',function(e){
    if(e.target.closest('[data-menu-toggle]')){
      e.preventDefault();
      openMobileMenu();
      return;
    }
    if(e.target.closest('[data-menu-close]') || e.target.closest('[data-mobile-overlay]')){
      closeMobileMenu();
      return;
    }
    if(e.target.closest('[data-mobile-menu] a')){
      closeMobileMenu();
    }
    if(e.target.closest('[data-cart-toggle]')){
      e.preventDefault();
      refreshCart().then(openDrawer);
      return;
    }
    if(e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')){
      closeDrawer();
      return;
    }
    const incBtn=e.target.closest('[data-qty-increase]');
    const decBtn=e.target.closest('[data-qty-decrease]');
    const removeBtn=e.target.closest('[data-remove-line]');
    if(incBtn || decBtn || removeBtn){
      e.preventDefault();
      const row=e.target.closest('[data-line]');
      if(!row) return;
      const line=parseInt(row.getAttribute('data-line'),10);
      const qtyEl=row.querySelector('[data-qty-value]');
      const current=qtyEl?parseInt(qtyEl.textContent,10):1;
      if(removeBtn){ changeLine(line,0); return; }
      const next=incBtn ? current+1 : Math.max(0,current-1);
      changeLine(line,next);
    }

    const filter=e.target.closest('.cat-filter[data-filter]');
    if(filter){
      document.querySelectorAll('.cat-filter').forEach(function(b){b.classList.remove('active');b.setAttribute('aria-pressed','false');});
      filter.classList.add('active');
      filter.setAttribute('aria-pressed','true');
      const cat=filter.getAttribute('data-filter');
      const grid=filter.closest('.wrap') || document;
      grid.querySelectorAll('[data-prod-cat]').forEach(function(card){
        card.style.display=(cat==='all' || card.getAttribute('data-prod-cat')===cat) ? '' : 'none';
      });
    }
  });

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){ closeDrawer(); closeMobileMenu(); }
  });

  document.addEventListener('submit',function(e){
    const discountForm=e.target.closest('[data-discount-form]');
    if(discountForm){
      e.preventDefault();
      const code=(discountForm.querySelector('input[name="discount"]').value||'').trim();
      if(!code) return;
      window.location.href='/discount/'+encodeURIComponent(code)+'?redirect=%2Fcheckout';
      return;
    }

    const form=e.target.closest('[data-product-form]');
    if(!form) return;
    e.preventDefault();
    const data=new FormData(form);
    const buttons=document.querySelectorAll('button[type="submit"][form="productForm"], #productForm button[type="submit"]');
    function restore(text,cls){
      buttons.forEach(function(b){
        const old=b.getAttribute('data-label') || b.textContent;
        b.setAttribute('data-label',old);
        b.textContent=text;
        b.classList.add(cls);
        setTimeout(function(){b.textContent=b.getAttribute('data-label');b.classList.remove(cls);},1600);
      });
    }
    fetch(form.action,{method:'POST',headers:{Accept:'application/json'},body:data})
      .then(function(res){
        return res.json().catch(function(){return {};}).then(function(body){
          if(!res.ok){ throw new Error((body && body.description) || 'We could not add that to your cart.'); }
          return body;
        });
      })
      .then(refreshCart)
      .then(function(){
        restore('Added','added');
        openDrawer();
      })
      .catch(function(err){
        restore('Unavailable','error');
        const box=form.querySelector('[data-form-error]');
        if(box){ box.textContent=err.message; box.hidden=false; }
      });
  });
})();
